import moment, { Moment } from "moment/moment";
import { PenaltyType } from "./enum/penaltyType";

export interface PenaltyDto {
  disadvantages: DisadvantageDto[] | null;
  noShows: NoShowDto[] | null;
  violations: ViolationDto[] | null;
}

export class Penalty {
  disadvantages: Disadvantage[] | null;
  noShows: NoShow[] | null;
  violations: Violation[] | null;

  constructor(dto: PenaltyDto) {
    this.disadvantages =
      dto.disadvantages?.map((it) => new Disadvantage(it)) || [];
    this.noShows = dto.noShows?.map((it) => new NoShow(it)) || [];
    this.violations = dto.violations?.map((it) => new Violation(it)) || [];
  }
}

export interface DisadvantageDto {
  id: number;
  startAt: string;
  endAt: string | null;
  memo: string | null;
}

export class Disadvantage {
  id: number;
  startAt: Moment;
  endAt: Moment | null;
  memo: string | null;

  constructor(dto: DisadvantageDto) {
    this.id = dto.id;
    this.startAt = moment(dto.startAt);
    this.endAt = dto.endAt ? moment(dto.endAt) : null;
    this.memo = dto.memo;
  }
}

export interface NoShowDto {
  id: number;
  startAt: string;
  endAt: string | null;
}

export class NoShow {
  id: number;
  startAt: Moment;
  endAt: Moment | null;

  constructor(dto: NoShowDto) {
    this.id = dto.id;
    this.startAt = moment(dto.startAt);
    this.endAt = dto.endAt ? moment(dto.endAt) : null;
  }
}

export interface ViolationDto {
  id: number;
  eventId: number;
  eventRewardId: number;
  type: string;
}

export class Violation {
  id: number;
  eventId: number;
  eventRewardId: number;
  type: PenaltyType;

  constructor(dto: ViolationDto) {
    this.id = dto.id;
    this.eventId = dto.eventId;
    this.eventRewardId = dto.eventRewardId;
    this.type = PenaltyType[dto.type as keyof typeof PenaltyType];
  }
}
